// File: frontend/src/config/yazykiObrashcheniy.js
// Version: 1.0 (quick-260911-27v)
// Date: 2026-09-11
// Назначение: ЕДИНСТВЕННЫЙ держатель языков обращения на фронте.
//
// 🔴 СЛОВАРЬ ЗАКРЫТ, И ЗАКРЫТ ПО ДАННЫМ, А НЕ ПО АТЛАСУ (Д-06).
//    В боевых данных два языка: `ru` 73 и `en` 36. «ES», нарисованный в
//    прототипе, СЮДА НЕ ПЕРЕНЕСЁН: испанского в данных нет вовсе, и тег,
//    которому нечем наполниться, — украшение. Тот же довод уже записан в
//    `historyEvents.js` про метку без писателя.
//
// 🔴 НЕЗНАКОМЫЙ КОД ПЕЧАТАЕТСЯ САМ СОБОЙ И СЧИТАЕТСЯ. Подстановка «по
//    умолчанию» (скажем, EN) была бы НЕОТЛИЧИМА от настоящего опознания:
//    экран сказал бы «английский» про язык, которого не знает. Образец —
//    `metkaTipa` в `historyEvents.js` и `origin_unresolved` на сервере.
//
// 🔴 ПУСТОЙ ЯЗЫК — НЕ «НЕЗНАКОМЫЙ». `null`/`''` означает «не заполнено», и тега
//    тогда НЕТ ВОВСЕ. Слить это с незнакомым кодом значило бы считать пустоту
//    ошибкой опознания.
//
// 🔴 ЦВЕТОВ ЗДЕСЬ НЕТ. Тег красится классом раздела 11 из токенов §3.1.

export const YAZYKI = {
    ru: { metka: 'RU', nazvanie: 'русский' },
    en: { metka: 'EN', nazvanie: 'английский' },
};

// Сколько раз код языка оказался вне словаря. Наблюдаемая величина, а не журнал:
// ноль означает «все коды словарю известны», а не «мы не смотрели».
let _neopoznannyh = 0;

export const schetNeopoznannyhYazykov = () => _neopoznannyh;

// Чистый предикат без побочного счёта — для показа на экране.
export const izvestenYazyk = (kod) =>
    Object.prototype.hasOwnProperty.call(YAZYKI, String(kod || '').toLowerCase());

// Метка языка. `null` — «языка нет», тег не рисуется.
// Незнакомый код возвращается САМ СОБОЙ (в верхнем регистре, как и знакомые) и
// увеличивает счётчик.
export const metkaYazyka = (kod) => {
    const k = String(kod || '').trim().toLowerCase();
    if (!k) return null;                       // ПУСТО — это не «незнакомо»
    if (Object.prototype.hasOwnProperty.call(YAZYKI, k)) return YAZYKI[k].metka;
    _neopoznannyh += 1;                        // ЯЗЫК НЕ ОПОЗНАН
    return k.toUpperCase();
};

// Опознан ли показанный тег. Экрану нужно ОТЛИЧАТЬ опознанный тег от чужого,
// не полагаясь на счётчик модуля: тот растёт при каждой перерисовке.
export const yazykOpoznan = (kod) => izvestenYazyk(kod);

// Разные коды, встретившиеся в списке и словарю НЕ известные. Чистая функция.
export const neopoznannyeYazyki = (obrashcheniya) => Array.from(new Set(
    (obrashcheniya || []).map((o) => o && o.language)
        .filter((k) => k && !izvestenYazyk(k))
        .map((k) => String(k).toLowerCase()),
));

export default YAZYKI;
